export const ExhaustiveIcon = () => (
  <svg
    aria-hidden="true"
    className="h-[54px] w-[54px] shrink-0"
    fill="none"
    viewBox="0 0 54 54"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="27" cy="27" fill="#ed630d" r="27" />
    <path
      d="M29.179,12.372H19.988L17.2,4.037a1.012,1.012,0,0,0-1.9,0L12.5,12.372H3.25a1,1,0,0,0-1,1,.735.735,0,0,0,.019.169.96.96,0,0,0,.419.706l7.554,5.323L7.342,28a1,1,0,0,0,.344,1.125.967.967,0,0,0,.562.244,1.225,1.225,0,0,0,.625-.225l7.373-5.255,7.373,5.255a1.171,1.171,0,0,0,.625.225.9.9,0,0,0,.556-.244A.99.99,0,0,0,25.143,28l-2.9-8.429L29.735,14.2l.181-.156a1.048,1.048,0,0,0,.325-.669A1.058,1.058,0,0,0,29.179,12.372Z"
      fill="#fff"
      transform="translate(10.755 10.629)"
    />
  </svg>
);

export const EasyIcon = () => (
  <svg
    aria-hidden="true"
    className="h-[54px] w-[54px] shrink-0"
    fill="none"
    viewBox="0 0 54 54"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="27" cy="27" fill="#ed630d" r="27" />
    <path
      d="M1.5,24.288H6.058V10.615H1.5ZM26.567,11.755a2.286,2.286,0,0,0-2.279-2.279H17.1l1.082-5.207.034-.365a1.715,1.715,0,0,0-.5-1.208L16.506,1.5l-7.5,7.509a2.228,2.228,0,0,0-.672,1.607V22.009a2.286,2.286,0,0,0,2.279,2.279H20.87a2.263,2.263,0,0,0,2.1-1.39l3.441-8.033a2.251,2.251,0,0,0,.16-.832V11.857l-.011-.011Z"
      fill="#fff"
      transform="translate(12.967 14.106)"
    />
  </svg>
);

export const PremiumIcon = () => (
  <svg
    aria-hidden="true"
    className="h-[54px] w-[54px] shrink-0"
    fill="none"
    viewBox="0 0 54 54"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-0.379)">
      <circle cx="27" cy="27" fill="#ed630d" r="27" transform="translate(0.379)" />
      <path
        d="M21.583,4.5H17.318a1.5,1.5,0,0,0-1.072.468l-4.881,5.02c0,.006-.01.017-.015.022a2.416,2.416,0,0,0-.1,3.123,1.908,1.908,0,0,0,2.785.151c0-.006.015-.006.02-.011L18.018,9.19a.738.738,0,0,1,1.122.056.97.97,0,0,1-.05,1.26l-1.3,1.333,7.229,6.592a3.813,3.813,0,0,1,.392.429V8.069L22.705,5.024A1.5,1.5,0,0,0,21.583,4.5ZM27.01,8.081V20.568A1.694,1.694,0,0,0,28.6,22.353h3.178V8.081Zm2.383,12.488a.9.9,0,1,1,.794-.892A.85.85,0,0,1,29.394,20.568ZM0,22.347H3.178a1.694,1.694,0,0,0,1.589-1.785V8.081H0Zm2.383-3.564a.9.9,0,0,1,0,1.785.9.9,0,0,1,0-1.785Zm21.643,1.037-7.413-6.76-1.49,1.534a3.311,3.311,0,0,1-5.05-.245,4.374,4.374,0,0,1,.218-5.672L14.354,4.5H10.193a1.5,1.5,0,0,0-1.122.524L6.355,8.069V20.557h.909l4.493,4.568a2.946,2.946,0,0,0,4.469-.519l.01-.011.889.864a1.711,1.711,0,0,0,2.6-.3l1.559-2.153.268.245a1.471,1.471,0,0,0,2.234-.262l.472-.653a1.942,1.942,0,0,0-.228-2.515Z"
        fill="#fff"
        transform="translate(11.112 11.788)"
      />
    </g>
  </svg>
);

export const InnovationIcon = () => (
  <svg
    aria-hidden="true"
    className="h-[54px] w-[54px] shrink-0"
    fill="none"
    viewBox="0 0 54 54"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="27" cy="27" fill="#ed630d" r="27" />
    <path
      d="M11.466,15.049h0c0-.725.06-.391-3.809-8.13a2.152,2.152,0,0,0-3.846,0C-.092,14.725,0,14.348,0,15.049H0c0,1.979,2.567,3.583,5.733,3.583S11.466,17.028,11.466,15.049ZM5.733,7.883l3.225,6.45H2.508Zm22.932,7.166c0-.725.06-.391-3.809-8.13a2.152,2.152,0,0,0-3.846,0c-3.9,7.805-3.809,7.428-3.809,8.13h0c0,1.979,2.567,3.583,5.733,3.583s5.733-1.6,5.733-3.583Zm-8.957-.717,3.225-6.45,3.225,6.45Zm3.942,5.733H15.766V6.864A3.586,3.586,0,0,0,17.844,4.3h5.805a.716.716,0,0,0,.717-.717V2.15a.716.716,0,0,0-.717-.717H17.183a3.551,3.551,0,0,0-5.7,0H5.016A.716.716,0,0,0,4.3,2.15V3.583a.716.716,0,0,0,.717.717h5.805A3.586,3.586,0,0,0,12.9,6.864v13.2H5.016a.716.716,0,0,0-.717.717v1.433a.716.716,0,0,0,.717.717H23.649a.716.716,0,0,0,.717-.717V20.783A.716.716,0,0,0,23.649,20.066Z"
      fill="#fff"
      transform="translate(12.667 15.534)"
    />
  </svg>
);
